<script setup lang="ts">
/**
 * The read-only preview, in a modal. A host and nothing else: `AssessmentPreview` keeps its own
 * guarantee that it writes nothing, and the only state here is the open flag. `OverlayDefault`
 * renders its slot under `v-if`, so each open starts the stepper on the screen selected in the rail.
 */
import { ModalDefault } from '@shared/ui/modals'
import { BtnSecondary } from '@shared/ui/buttons'

import { useAssessmentPreviewModal } from '../../../model/assessments/assessment-preview-modal.hook'
import AssessmentPreview from '../../assessments/preview/AssessmentPreview.vue'

defineOptions({
  name: 'ModalAssessmentPreview',
})

const {
  refIsOpen,
  closePreview,
} = useAssessmentPreviewModal()
</script>

<template>
  <ModalDefault
    :show="refIsOpen"
    title="Preview"
    class-name="modal-assessment-preview"
    is-close-button
    @click:overlay="closePreview"
    @click:close="closePreview"
  >
    <AssessmentPreview />

    <template #controls>
      <BtnSecondary
        text="Close"
        @click="closePreview"
      />
    </template>
  </ModalDefault>
</template>

<style scoped lang="scss" src="./ModalAssessmentPreview.scss" />
